module.exports = __webpack_public_path__ + "static/media/color_rendering_for_hotel_lobby_mural_2016.17fb1cd5.webp";